export default {
    alert(message, type) {
        alert(`An error occured with status: ${type} and message:${message}. Please try again.`);
    }
}